// extracted by css-extract-rspack-plugin
export default {"visibilityLabel":"Packages-module__visibilityLabel__nQonc","packageIconWrapper":"Packages-module__packageIconWrapper__SCSwe","downloadIcon":"Packages-module__downloadIcon__DpeRk"};